module.exports = __webpack_public_path__ + "static/media/horizontalNonExpandable.f3551612.svg";